"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTemplateDisabled = void 0;
const types_1 = require("@framework/types");
const constants_1 = require("@dzambalaorg/constants");
const isTemplateDisabled = (chainId) => {
    const disabledTemplates = [];
    // Deployed through corresponding mechanics
    disabledTemplates.push(types_1.Erc721ContractTemplates.RAFFLE, types_1.Erc721ContractTemplates.LOTTERY);
    if (process.env.NODE_ENV === constants_1.NodeEnv.production) {
        // Rent (is not tested yet)
        disabledTemplates.push(types_1.Erc721ContractTemplates.RENTABLE, types_1.Erc721ContractTemplates.BLACKLIST_DISCRETE_RENTABLE, types_1.Erc721ContractTemplates.BLACKLIST_DISCRETE_RENTABLE_RANDOM);
        // Genes
        disabledTemplates.push(types_1.Erc721ContractTemplates.GENES);
        // ChainLink
        if (!types_1.ChainLinkV2SupportedChains[chainId]) {
            disabledTemplates.push(types_1.Erc721ContractTemplates.RANDOM, types_1.Erc721ContractTemplates.DISCRETE_RANDOM, types_1.Erc721ContractTemplates.BLACKLIST_DISCRETE_RANDOM, types_1.Erc721ContractTemplates.BLACKLIST_RANDOM);
        }
    }
    return disabledTemplates;
};
exports.isTemplateDisabled = isTemplateDisabled;
//# sourceMappingURL=utils.js.map